import script from "./Library.vue?vue&type=script&setup=true&lang=js"
export * from "./Library.vue?vue&type=script&setup=true&lang=js"

import "./Library.vue?vue&type=style&index=0&id=23b157da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b157da"]])

export default __exports__